export default __webpack_public_path__ + "static/media/FotoEli.c5ee1184.jfif";